//
//
//
//
//
//
import echarts from 'echarts';
import 'echarts/lib/chart/gauge';
import 'echarts/lib/component/tooltip';
import 'echarts/lib/component/title';
export default {
  props: {
    showIcon: {
      type: Boolean,
      default: true
    },
    width: {
      type: String,
      default: '450px'
    },
    height: {
      type: String,
      default: '280px'
    },
    top: {
      type: String,
      default: '18px'
    },
    left: {
      type: String,
      default: '0'
    }
  },
  data: function data() {
    return {
      chart: null,
      myChart: null,
      showLegend: false,
      smallLabelData: [],
      labelData: []
    };
  },
  methods: {
    setLegendShow: function setLegendShow(val) {
      this.showLegend = val;

      if (val) {
        this.option.legend.data = this.labelData;
      } else {
        this.option.legend.data = this.smallLabelData;
      }

      this.myChart.setOption(this.option);
    },
    //selectedObj 是否有自定义不显示的因子 setIndex要展示前几项
    initBarChart: function initBarChart() {
      var _this = this;

      var xAxisData = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
      var optionData = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
      var title = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '水位';
      this.option = {
        title: {
          textStyle: {
            align: 'center',
            color: '#fff',
            fontSize: 20
          },
          top: '5%',
          left: 'center'
        },
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            lineStyle: {
              color: {
                type: 'linear',
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [{
                  offset: 0,
                  color: 'rgba(0, 255, 233,0)'
                }, {
                  offset: 0.5,
                  color: 'rgba(255, 255, 255,1)'
                }, {
                  offset: 1,
                  color: 'rgba(0, 255, 233,0)'
                }],
                global: false
              }
            }
          }
        },
        grid: {
          // top: '15%',
          // left: '5%',
          // right: '5%',
          // bottom: '15%'
          containLabel: true
        },
        xAxis: [{
          type: 'category',
          axisLine: {
            show: true
          },
          splitArea: {
            // show: true,
            color: '#f00',
            lineStyle: {
              color: '#f00'
            }
          },
          axisLabel: {
            color: '#fff'
          },
          splitLine: {
            show: false
          },
          boundaryGap: false,
          data: xAxisData
        }],
        yAxis: [{
          name: 'm',
          type: 'value',
          // min: 0,
          // max: 140,
          splitNumber: 4,
          splitLine: {
            show: false,
            lineStyle: {
              color: '#fff'
            }
          },
          axisLine: {
            show: true,
            lineStyle: {
              color: '#DCE2E8'
            }
          },
          axisLabel: {
            textStyle: {
              color: '#fff',
              fontSize: 10
            }
          },
          axisTick: {
            show: true
          }
        }],
        series: [{
          name: title,
          type: 'line',
          // smooth: true, //是否平滑
          showAllSymbol: true,
          // symbol: 'image://./static/images/guang-circle.png',
          symbol: 'circle',
          symbolSize: 15,
          lineStyle: {
            normal: {
              color: '#0ff',
              shadowColor: 'rgba(0, 0, 0, .3)',
              shadowBlur: 0,
              shadowOffsetY: 5,
              shadowOffsetX: 5
            }
          },
          label: {
            show: false,
            position: 'top',
            textStyle: {
              color: '#0ff'
            }
          },
          itemStyle: {
            color: '#0ff',
            borderColor: '#fff',
            borderWidth: 3,
            shadowColor: 'rgba(0, 0, 0, .3)',
            shadowBlur: 0,
            shadowOffsetY: 2,
            shadowOffsetX: 2
          },
          tooltip: {
            show: true
          },
          areaStyle: {
            normal: {
              color: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                offset: 0,
                color: 'rgba(108,80,243,0.3)'
              }, {
                offset: 1,
                color: 'rgba(108,80,243,0)'
              }], false),
              shadowColor: 'rgba(108,80,243, 0.9)',
              shadowBlur: 20
            }
          },
          data: optionData
        }]
      };
      this.chart = this.$refs.chartTide;
      this.myChart = this.$echarts.init(this.chart);
      this.myChart.setOption(this.option);
      window.addEventListener('resize', function () {
        _this.myChart.resize();
      });
    }
  }
};